/**
 * CSRF Token Yardımcıları
 *
 * Laravel XSRF-TOKEN cookie'sinden token okur. Cookie her response'ta güncellenir,
 * bu sayede Inertia SPA geçişlerinde ve login sonrası session yenilendiğinde
 * her zaman güncel token kullanılır. Meta tag yalnızca ilk full page load'da
 * set edildiği için stale kalabilir.
 */

/**
 * CSRF token'ı cookie'den oku, fallback olarak meta tag kullan.
 */
export function getCsrfToken(): string {
    const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
    if (match) return decodeURIComponent(match[1]);
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

/**
 * fetch çağrıları için standart CSRF ve JSON header'ları.
 * Tüm POST/PUT/DELETE isteklerinde kullanın.
 */
export function csrfHeaders(): Record<string, string> {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken(),
    };
}
